import React from 'react';
import Skeleton from './Skeleton';
import { BlockAuto, AutoImage, AutoText, BlockCarousel, Slides, Slide } from './SkeletonPage.styled';

const PageSkeleton = () => {
  return (
    <div>
      <Skeleton height="70px" width="100%"/>
      <BlockAuto>
        <AutoImage>
          <Skeleton height="300px"/>
        </AutoImage>
        <AutoText>
          <Skeleton height="50px"/>
          <Skeleton height="16px"/>
          <Skeleton height="16px" width="98%"/>
          <Skeleton height="16px" width="92%"/>
          <Skeleton height="16px" width="26%"/>
        </AutoText>
      </BlockAuto>
      <Skeleton width="100%" height="48px"/>
      <BlockCarousel>
        <Skeleton width="67%" height="32px"/>
        <Slides>
          <Slide>
            <Skeleton width="100%" height="70%"/>
            <Skeleton width="100%" height="24px"/>
            <Skeleton width="100%" height="12px"/>
            <Skeleton width="77%" height="12px"/>
          </Slide>
          <Slide>
            <Skeleton width="100%" height="70%"/>
            <Skeleton width="100%" height="24px"/>
            <Skeleton width="100%" height="12px"/>
            <Skeleton width="77%" height="12px"/>
          </Slide>
          <Slide>
            <Skeleton width="100%" height="70%"/>
            <Skeleton width="100%" height="24px"/>
            <Skeleton width="100%" height="12px"/>
            <Skeleton width="77%" height="12px"/>
          </Slide>
          <Slide>
            <Skeleton width="100%" height="70%"/>
            <Skeleton width="100%" height="24px"/>
            <Skeleton width="100%" height="12px"/>
            <Skeleton width="77%" height="12px"/>
          </Slide>
        </Slides>
      </BlockCarousel>
    </div>
  );
};

export default PageSkeleton;
